import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {},
});

export default useStyles;
